import type { FC, SVGProps } from 'react';

const Progress: FC<SVGProps<SVGSVGElement>> = props => {
    return (
        <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.078 14.522l-2.18.584a11.999 11.999 0 0020.076 5.38A12 12 0 0015.594.408L15.01 2.59c5.196 1.393 8.28 6.734 6.888 11.93-1.393 5.197-6.734 8.28-11.93 6.888a9.737 9.737 0 01-6.89-6.887z"
                fill="#177DDC"
            />
        </svg>
    );
};

export default Progress;
